"use client"
import React, { useState } from 'react'
import { getCurLanguage } from 'helpers/country'
import { configKey, setCookie } from 'helpers/cookies'
import { formatTemplateString } from 'helpers/formatter'
import styled from '@emotion/styled';
import { defaultCountryKey, languages } from 'helpers/country.base'

// function replaceLanguageCode(url, languageCode) {
//   const regex = /^(https?:\/\/(?:[^\/]+|\blocalhost\b)(?::\d+)?)(?:\/[a-zA-Z-]+)?/;
//   return url.replace(regex, `$1/${languageCode}`);
// }

const companyInfo = {
  ph: {
    companyNameKey: 'corporationCopyright',
  },
  id: {
    companyNameKey: 'IndonesiaPTCopyright',
  },
  sg: {
    companyNameKey: 'SingaporeYoloCopyright',
  },
  jp: {
    companyNameKey: 'JapanYoloCopyright',
  }
}
const Copyright = (props: any) => {
  const { data, countryKey } = props

  const { currentLangFullName } = getCurLanguage()
  const currentYear = new Date().getFullYear()
  const companyNameKey = companyInfo[countryKey]?.companyNameKey || companyInfo.sg.companyNameKey
  const companyName = data?.foot[companyNameKey] || ''

  const [showModalType, setShowModalType] = useState('')

  // const handleChooseLan = (lang)=> {
  //   const route = replaceLanguageCode(window.location.href, lang)
  //   router.push(route)
  // }

  const handleSwitchNation = (lang) => {
    const { origin, pathname } = window.location

    const query = `/${lang}`
    const newOrigin = origin

    let restPath = pathname.split('/').slice(2).join('/')
    restPath = restPath ? `/${restPath}` : ''

    // store this in cookies. then the others link request server can take it to server
    setCookie(configKey, `${defaultCountryKey()}_${lang}`)
    window.location.href = newOrigin + query + restPath + location.search
  }

  return (
    <CopyrightStyle>
      <div className='copyright_wrap'>
        <span className='copyright'>
          {formatTemplateString(data?.foot['copyright'], currentYear, companyName)}
        </span>
        <span
          className='change_lan'
          onMouseEnter={() => setShowModalType('choose_lan')}
          onMouseLeave={() => setShowModalType('')}
        >
          <GlobalIcon />
          <span className='current_lan'>{currentLangFullName}</span>
          {showModalType === 'choose_lan' ? <UpIcon /> : <DownIcon />}
          {showModalType === 'choose_lan' ? (
            <div className='choose_lan'>
              {languages.map((item) => (
                <div
                  key={item.value}
                  className='item'
                  onClick={() => handleSwitchNation(item.value)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          ) : null}
        </span>
      </div>
    </CopyrightStyle>
  )
}

export default Copyright

const CopyrightStyle = styled.div`
  margin-top: 40px;
  /* background: #2B2B2B; */
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  /* padding: 20px 0; */
  .copyright_wrap {
    height: 62px;
    line-height: 62px;
    display: flex;
    justify-content: space-between;
    /* max-width: 1136px; */
    /* margin: 0 auto; */
    line-height: 22px;
    color: #acaeb1;
    font-size: 14px;
    font-weight: 400;
    .copyright {
      font-family: 'PingFang SC' !important;
      height: 62px;
      line-height: 62px;
    }
    .change_lan {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .current_lan {
        color: #b8b8b8;
        margin: 0 10px;
        &:hover {
          color: #ffffff;
        }
      }
      .choose_lan {
        position: absolute;
        right: 0;
        bottom: 58px;
        z-index: 1001;
        display: flex;
        width: 190px;
        padding: 12px 11px 12px 12px;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 4px;
        background: #ffffff;
        border-radius: 12px;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
        transition: visibility 0.2s ease-in-out; /* 添加过渡效果 */
        .item {
          display: flex;
          height: 36px;
          padding: 0px 8px;
          align-items: center;
          align-content: center;
          gap: 8px;
          align-self: stretch;
          flex-wrap: wrap;
          color: #121212;
          font-size: 14px;
          &:hover {
            border-radius: 8px;
            background-color: #f8f9fa;
          }
        }
      }
    }
  }
`

const GlobalIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.31711 3.73047C4.59579 2.45179 6.33005 1.73343 8.13838 1.73343V1.76772C9.58645 1.84719 10.7651 4.53818 10.8855 7.95106H14.0833H14.6833V8.55105C14.6833 10.3594 13.9649 12.0936 12.6862 13.3723C11.4075 14.651 9.67327 15.3694 7.86494 15.3694V15.2717C6.48889 15.0322 5.38642 12.4305 5.26118 9.15174H1.92007H1.32007V8.55174C1.32007 6.74341 2.03842 5.00915 3.31711 3.73047ZM6.46211 9.15174C6.52343 10.638 6.80017 11.9285 7.18356 12.8468C7.4027 13.3717 7.63309 13.7183 7.82759 13.9153C7.92147 14.0104 7.99172 14.0552 8.03162 14.0748C8.05086 14.0842 8.06264 14.0876 8.06743 14.0888C8.06996 14.0894 8.07136 14.0896 8.07182 14.0896L8.07246 14.0897L8.07311 14.0896C8.07357 14.0896 8.07497 14.0894 8.07749 14.0888C8.08229 14.0876 8.09407 14.0842 8.1133 14.0748C8.15321 14.0552 8.22346 14.0104 8.31734 13.9153C8.51184 13.7183 8.74222 13.3717 8.96137 12.8468C9.34482 11.9284 9.62158 10.6376 9.68284 9.15105H8.13838V9.15174H6.46211ZM7.86494 7.95174H6.46021C6.51751 6.44532 6.79606 5.13689 7.18356 4.20876C7.4027 3.68387 7.63309 3.33734 7.82759 3.1403C7.92147 3.04519 7.99172 3.00039 8.03162 2.98083C8.05086 2.9714 8.06264 2.96799 8.06743 2.96683C8.06996 2.96621 8.07136 2.96602 8.07182 2.96596L8.07246 2.96591L8.07311 2.96596C8.07357 2.96602 8.07497 2.96621 8.07749 2.96683C8.08229 2.96799 8.09407 2.9714 8.1133 2.98083C8.15321 3.00039 8.22346 3.04519 8.31734 3.1403C8.51184 3.33734 8.74222 3.68387 8.96137 4.20876C9.34881 5.13675 9.62733 6.44492 9.68469 7.95106H7.86494V7.95174ZM5.25942 7.95174H2.55218C2.68849 6.68228 3.25439 5.49024 4.16563 4.579C4.77605 3.96858 5.51247 3.51313 6.31375 3.23797C5.72381 4.36465 5.32656 6.04564 5.25942 7.95174ZM9.83348 13.8132C10.4173 12.6959 10.8119 11.0352 10.8838 9.15105H13.4511C13.3148 10.4205 12.7489 11.6126 11.8377 12.5238C11.264 13.0975 10.579 13.5343 9.83348 13.8132ZM14.5333 6.96077L14.5895 3.90673L13.87 4.40254C13.7099 4.18026 13.5294 3.94641 13.3383 3.71878C12.8775 3.16974 12.2789 2.56384 11.6907 2.28236C11.3918 2.13931 11.0336 2.26566 10.8905 2.56457C10.7475 2.86347 10.8738 3.22175 11.1727 3.36479C11.5114 3.52685 11.9702 3.95536 12.4192 4.4903C12.5882 4.69159 12.7448 4.89458 12.8816 5.08357L11.9521 5.72403L14.5333 6.96077ZM1.52549 10.144V13.1985L2.23623 12.6893C2.40036 12.9086 2.58511 13.1391 2.78033 13.3631C3.25123 13.9036 3.86085 14.4984 4.4541 14.769C4.75559 14.9065 5.11148 14.7736 5.249 14.4721C5.38652 14.1706 5.2536 13.8147 4.95211 13.6772C4.61055 13.5214 4.14389 13.1014 3.68509 12.5748C3.51245 12.3767 3.35213 12.1766 3.2119 11.9902L4.12905 11.333L1.52549 10.144Z'
        fill='#B8B8B8'
      />
    </svg>
  )
}

const UpIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.19526 11.6903C1.93491 11.4299 1.93491 11.0078 2.19526 10.7475L7.5286 5.41412C7.78895 5.15378 8.21106 5.15378 8.4714 5.41412L13.8047 10.7475C14.0651 11.0078 14.0651 11.4299 13.8047 11.6903C13.5444 11.9506 13.1223 11.9506 12.8619 11.6903L8 6.82834L3.13807 11.6903C2.87772 11.9506 2.45561 11.9506 2.19526 11.6903Z'
        fill='white'
        fillOpacity='0.7'
      />
    </svg>
  )
}

const DownIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.8047 5.4141C14.0651 5.67445 14.0651 6.09656 13.8047 6.35691L8.4714 11.6902C8.21105 11.9506 7.78894 11.9506 7.5286 11.6902L2.19526 6.35691C1.93491 6.09656 1.93491 5.67445 2.19526 5.4141C2.45561 5.15375 2.87772 5.15375 3.13807 5.4141L8 10.276L12.8619 5.4141C13.1223 5.15375 13.5444 5.15375 13.8047 5.4141Z'
        fill='white'
        fillOpacity='0.7'
      />
    </svg>
  )
}